import type { ReactNode } from "react";
import { Header } from "./header";
import { Footer } from "./footer";
import { AiChat } from "./ai-chat";
import { useSiteSettings } from "@/lib/cms";
import { useApplyPrimaryColor } from "@/lib/theme";
import { useSitePreviewBridge, isInPreviewFrame } from "@/lib/preview-bridge";

export function PublicLayout({ children }: { children: ReactNode }) {
  const { brand } = useSiteSettings();
  // Re-theme the site from the admin-chosen brand primary colour.
  useApplyPrimaryColor(brand.primaryColor);
  // When embedded in the admin split-screen preview, react to scroll requests.
  useSitePreviewBridge();
  const inPreview = isInPreviewFrame();

  return (
    // lg:pl-12 leaves room for the fixed left vertical sidebar (w-12)
    <div className="min-h-screen flex flex-col bg-white lg:pl-12">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      {/* The floating chat widget is noise inside the editor preview. */}
      {!inPreview && <AiChat />}
    </div>
  );
}
